module.exports = __webpack_public_path__ + "static/img/g_1.982f2c3a.png";